export const suggestNextMaintenanceDate = (completedDate, intervalDays) => {
  if (!completedDate || !intervalDays) return '';
  const base = new Date(`${completedDate}T00:00:00`);
  if (Number.isNaN(base.getTime())) return '';
  base.setDate(base.getDate() + Number(intervalDays));
  return base.toISOString().slice(0, 10);
};

export const daysUntilDate = (isoDate) => {
  if (!isoDate) return null;
  const target = new Date(`${isoDate}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((target - today) / 86400000);
};

export const downloadCsv = (filename, headers, rows) => {
  const escape = (value) => {
    const text = value == null ? '' : String(value);
    if (/[",\n;]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
    return text;
  };

  const lines = [
    headers.map(escape).join(';'),
    ...rows.map((row) => row.map(escape).join(';')),
  ];

  const blob = new Blob(['\uFEFF', lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const aggregateByKey = (items, keyFn, valueFn) => {
  const map = new Map();
  items.forEach((item) => {
    const key = keyFn(item) || '—';
    const current = map.get(key) || { key, count: 0, cost: 0 };
    current.count += 1;
    current.cost += Number(valueFn(item)) || 0;
    map.set(key, current);
  });
  return [...map.values()].sort((a, b) => b.count - a.count || b.cost - a.cost);
};
